<template>
  <div class="popover-content" v-if="data">
    <img class="close-btn" :src="require(`images_base/close.svg`)" alt="" @click="$emit('close')"/>
    <div class="title">{{data.constituency}}</div>
    <div class="other-data">
      <div>{{data.grc}}</div>
      <div>{{data.voters.toLocaleString()}} Electors</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: null
    }
  }
}
</script>

<style lang="scss">
.popover-content {
  padding: 8px 5px;
  z-index: 2;
  .close-btn {
    width: 10px;
    position: absolute;
    right: 0;
    top: 0;
    padding: 5px;
    cursor: pointer;
  }
  .title {
    padding: 0 20px 0 0;
    font-family: $font-OpenSans-Bold;
    font-size: 15px;
  }
  .other-data {
    font-size: 14px;
  }
}
</style>
